import { axios } from "lib/axios";
import { useNotificationStore } from "stores/notifications";
import { useMutation } from "react-query";

export const requestOtp = ({ data }) => {
  return axios.post(`/auth/mobile`, data);
};

export const useRequestOtp = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: (data) => {
      addNotification({
        type: "success",
        title: data.msg,
      });
    },
    ...config,
    mutationFn: requestOtp,
  });
};
